import { render, staticRenderFns } from "./CreateFormHeng.vue?vue&type=template&id=1206f3e8&scoped=true"
import script from "./CreateFormHeng.vue?vue&type=script&lang=js"
export * from "./CreateFormHeng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1206f3e8",
  null
  
)

export default component.exports